export default __webpack_public_path__ + "static/media/common_gnust.bd55a286.png";